if (!customElements.get('product-upsell')) {
  class ProductUpsell extends HTMLElement {
    constructor() {
      super();

      this.type = this.dataset.type;
      this.url = this.dataset.url;

      if (this.type === 'recommendations') {
        this.fetchRecommendations();
      } else {
        this.initSplide();
      }
    }

    initSplide() {

      this.slider = this.querySelector('.product-upsell__slider.splide');
      if (!this.slider) return;

      const splideUpsell = new Splide(this.slider, {
        arrows: true,
        pagination: false,
        mediaQuery: 'max',
        perPage: 3,
        gap: '1rem',
        focusableNodes: 'a, button, textarea, input:not([type="radio"]), select, iframe',
        slideFocus: false,
        breakpoints: {
          990: {
            gap: 0,
            perPage: 1,
            fixedWidth: '26.1rem',
            height: '41.2rem',
          },
        }
      })

      splideUpsell.on( 'mounted', () => {
        splideUpsell.Components.Slides.forEach(component => {
          const sizeVariantRadios = component.slide.querySelectorAll('label.visible-size input[type="radio"]')
          sizeVariantRadios.forEach(label => {
            label.addEventListener('keydown', (e) => e.stopPropagation())
          });
        })
      });

      splideUpsell.mount();
    }

    fetchRecommendations() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-upsell');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            this.initSplide();
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-upsell', ProductUpsell);
}
